<!-- Header -->
<div class="bb-page-header">
  <div class="bb-page-title-block">
    <span class="bb-eyebrow">{{ "new delivery star" | transloco }}</span>
    <h2 class="bb-page-title">{{ "new delivery star" | transloco }}</h2>
  </div>
</div>

<div class="bb-card bb-p-20">
  <form class="bb-w-100" [formGroup]="formInfo" (ngSubmit)="onSubmit()">
    <div class="bb-form-grid">
      @if(submitted && formInfo.invalid) {
      <div class="bb-form-alert bb-field-full" role="alert">
        {{ 'Review the delivery hero data before saving' | transloco }}
        @if(getMissingRequiredCount() > 0) {
        <span>
          ({{ getMissingRequiredCount() }} {{ 'fields need review' | transloco }})
        </span>
        }
      </div>
      }

      <!-- Arabic Name -->
      <div class="bb-field">
        <label class="bb-label" for="name_ar">{{ 'name ar' | transloco }}</label>
        <input
          class="bb-input"
          type="text"
          id="name_ar"
          formControlName="name_ar"
          placeholder="{{ 'name ar' | transloco }}"
          [ngClass]="{
            'is-invalid': formInfo.get('name_ar')?.touched && formInfo.get('name_ar')?.invalid,
            'is-valid': formInfo.get('name_ar')?.touched && formInfo.get('name_ar')?.valid
          }"
        />
        @if(shouldShowError('name_ar')) {
        <div class="bb-field-error">{{ getErrorMessage('name_ar', ('name ar' | transloco)) }}</div>
        }
      </div>

      <!-- English Name -->
      <div class="bb-field">
        <label class="bb-label" for="name_en">{{ 'name en' | transloco }}</label>
        <input
          class="bb-input"
          type="text"
          id="name_en"
          formControlName="name_en"
          placeholder="{{ 'name en' | transloco }}"
          [ngClass]="{
            'is-invalid': formInfo.get('name_en')?.touched && formInfo.get('name_en')?.invalid,
            'is-valid': formInfo.get('name_en')?.touched && formInfo.get('name_en')?.valid
          }"
        />
        @if(shouldShowError('name_en')) {
        <div class="bb-field-error">{{ getErrorMessage('name_en', ('name en' | transloco)) }}</div>
        }
      </div>

      <!-- Phone -->
      <div class="bb-field">
        <label class="bb-label" for="phone">{{ 'phone' | transloco }}</label>
        <input
          class="bb-input"
          type="text"
          id="phone"
          formControlName="phone"
          placeholder="{{ 'phone' | transloco }}"
          [ngClass]="{
            'is-invalid': formInfo.get('phone')?.touched && formInfo.get('phone')?.invalid,
            'is-valid': formInfo.get('phone')?.touched && formInfo.get('phone')?.valid
          }"
        />
        @if(shouldShowError('phone')) {
        <div class="bb-field-error">{{ getErrorMessage('phone', ('phone' | transloco)) }}</div>
        }
      </div>

      <!-- Number -->
      <div class="bb-field">
        <label class="bb-label" for="number">{{ 'number' | transloco }}</label>
        <input
          class="bb-input"
          type="text"
          id="number"
          formControlName="number"
          placeholder="{{ 'number' | transloco }}"
        />
      </div>

      <!-- National ID -->
      <div class="bb-field">
        <label class="bb-label" for="national_id">{{ 'national id' | transloco }}</label>
        <input
          class="bb-input"
          type="text"
          id="national_id"
          formControlName="national_id"
          placeholder="{{ 'national id' | transloco }}"
        />
      </div>

      <!-- Delivery Vehicle -->
      <div class="bb-field">
        <label class="bb-label" for="delivery_vehicle_id">{{ 'delivery vehicle' | transloco }}</label>
        <input
          class="bb-input"
          type="number"
          id="delivery_vehicle_id"
          formControlName="delivery_vehicle_id"
          placeholder="{{ 'delivery vehicle id' | transloco }}"
        />
      </div>

      <!-- Commission Type -->
      <div class="bb-field">
        <label class="bb-label" for="commission_type">{{ 'commission type' | transloco }}</label>
        <div class="bb-select-wrap">
          <select
            class="bb-select"
            id="commission_type"
            formControlName="commission_type"
            [ngClass]="{
              'is-invalid': formInfo.get('commission_type')?.touched && formInfo.get('commission_type')?.invalid,
              'is-valid': formInfo.get('commission_type')?.touched && formInfo.get('commission_type')?.valid
            }"
          >
            <option value="fixed">{{ 'fixed' | transloco }}</option>
            <option value="percentage">{{ 'percentage' | transloco }}</option>
          </select>
        </div>
        @if(shouldShowError('commission_type')) {
        <div class="bb-field-error">{{ getErrorMessage('commission_type', ('commission type' | transloco)) }}</div>
        }
      </div>

      <!-- Commission Value -->
      <div class="bb-field">
        <label class="bb-label" for="commission_value">{{ 'commission value' | transloco }}</label>
        <input
          class="bb-input"
          type="number"
          id="commission_value"
          formControlName="commission_value"
          placeholder="{{ 'commission value' | transloco }}"
          [ngClass]="{
            'is-invalid': formInfo.get('commission_value')?.touched && formInfo.get('commission_value')?.invalid,
            'is-valid': formInfo.get('commission_value')?.touched && formInfo.get('commission_value')?.valid
          }"
        />
        @if(shouldShowError('commission_value')) {
        <div class="bb-field-error">{{ getErrorMessage('commission_value', ('commission value' | transloco)) }}</div>
        }
      </div>

      <!-- Make it employee -->
      <div class="bb-field bb-field-full">
        <label class="bb-label">{{ 'Make it employee too' | transloco }}</label>
        <label class="bb-check-line">
          <input class="bb-checkbox" type="checkbox" formControlName="make_it_employee" />
          <span>{{ 'Make it employee too' | transloco }}</span>
        </label>
      </div>

      <!-- Employee fields -->
      <div class="bb-field bb-field-full" *ngIf="formInfo.get('make_it_employee')?.value">
        <div class="bb-form-grid">
          <div class="bb-field">
            <label class="bb-label" for="job_title">{{ 'job title' | transloco }}</label>
            <input
              class="bb-input"
              type="text"
              id="job_title"
              formControlName="job_title"
              placeholder="{{ 'job title' | transloco }}"
              [ngClass]="{
                'is-invalid': formInfo.get('job_title')?.touched && formInfo.get('job_title')?.invalid,
                'is-valid': formInfo.get('job_title')?.touched && formInfo.get('job_title')?.valid
              }"
            />
            @if(shouldShowError('job_title')) {
            <div class="bb-field-error">{{ getErrorMessage('job_title', ('job title' | transloco)) }}</div>
            }
          </div>

          <div class="bb-field">
            <label class="bb-label" for="salary">{{ 'salary' | transloco }}</label>
            <input
              class="bb-input"
              type="number"
              id="salary"
              formControlName="salary"
              placeholder="{{ 'salary' | transloco }}"
              [ngClass]="{
                'is-invalid': formInfo.get('salary')?.touched && formInfo.get('salary')?.invalid,
                'is-valid': formInfo.get('salary')?.touched && formInfo.get('salary')?.valid
              }"
            />
            @if(shouldShowError('salary')) {
            <div class="bb-field-error">{{ getErrorMessage('salary', ('salary' | transloco)) }}</div>
            }
          </div>
        </div>
      </div>

      <div class="bb-field bb-field-full">
        <div class="bb-flex bb-justify-end">
          <button type="submit" class="bb-btn bb-btn-primary bb-btn-wide" [disabled]="contentReady">
            {{ "Submit" | transloco }}
          </button>
        </div>
      </div>
    </div>
  </form>
</div>